import React from 'react';
import { Link } from 'react-router-dom';
import "../css/home.css";

const Home = (props) => {
   return (
      <div className="home-main-content">
         <div className="home-section" id="about">
            <img id="profile-pic" src={props.profilePic}/>
            <div id="cock" className="home-section-content">
               <h6>Web Developer</h6>
               <h1>Hi Max!</h1>
               <p>
                  I'm a full stack web developer based in Halifax, Nova Scotia. 
                  I write code to solve problems. I'm goal oriented, and build 
                  software with intention and purpose. If you're an employer 
                  looking to hire, <a href="#contact">connect with me here</a>.
               </p>
            </div>
         </div>

         <div className="home-section" id="about-mobile">
            <div id="about-mobile-div1" className="home-section-content">
               <img id="profile-pic-mobile" src={props.profilePic}/>
               <div id="cock-mobile">
                  <h6>Web Developer</h6>
                  <h1>Hi Max!</h1>
               </div>
            </div>
            <div id="about-mobile-div2" className="home-section-content">
               <p>
                  I'm a full stack web developer based in Halifax, Nova Scotia. 
                  I write code to solve problems. I'm goal oriented, and build 
                  software with intention and purpose. If you're an employer 
                  looking to hire, <a href="#contact">connect with me here</a>.
               </p>
            </div>
         </div>

         <div className="home-section" id="skills">
            <div className="home-section-content">
               <h1>My tech skills</h1>
               <p>
                  I have experience using a variety of web technologies. I've 
                  worked with SQL and NoSQL databases, built APIs, created 
                  interactive single-page apps, deployed to cloud providers, 
                  and much more.
               </p>
               <Link to="/resume">Go to resume</Link>
            </div>
            <div id="tech-icons">
               <img id="tech-icons-wide" src={props.techIconsWide}></img>
               <img id="tech-icons-square" src={props.techIcons}></img>
            </div>
         </div>

         <div className="home-section" id="skills-mobile">
            <div className="home-section-content">
               <h1>My tech skills</h1>
               <img id="tech-icons-wide" src={props.techIconsWide}></img>
               <p>
                  I have experience using a variety of web technologies. I've 
                  worked with SQL and NoSQL databases, built APIs, created 
                  interactive single-page apps, deployed to cloud providers, 
                  and much more.
               </p>
               <Link to="/resume">Go to resume</Link>
            </div>
         </div>

         <div className="home-section" id="education">
            <div id="school-logos">
               <img id="nscc-logo" src={props.nsccLogo}/>
               <img id="smu-logo" src={props.smuLogo}/>
            </div>
            <div id="education-section" className="home-section-content">
               <h1>Education</h1>
               <div id="schools">
                  <div id="nscc">
                     <div id="nscc-content">
                        <h3>Nova Scotia Community College</h3>
                        <h6>September 2020 - April 2022 (IT Web Programming)</h6>
                        <p>- Excelled in IT Web Programming. Gained tons of practical 
                           web development skills and was exposed to many 
                           different technologies.
                        </p>
                        <p>- Soon graduating with a diploma.</p>
                     </div>
                  </div>
                  <div id="smu">
                     <div id="smu-content">
                        <h3>Saint Mary's University</h3>
                        <h6>September 2018 - April 2019 (Computer Science)</h6>
                        <p>- Completed 1 year of computer science, but wanted 
                           more practical knowledge and skills.
                        </p>
                        <h6>September 2017 - April 2018 (Engineering)</h6>
                        <p>- Completed 1 year of engineering, but quickly realized 
                           I wasn't interested.
                        </p>
                     </div>   
                  </div>
               </div>
            </div>
         </div>

         <div className="home-section" id="education-mobile">
            <div id="education-section" className="home-section-content">
               <h1>Education</h1>
               <div id="schools">
                  <div id="nscc">
                     <div id="nscc-content">
                        <img id="nscc-logo" src={props.nsccLogo}/>
                        <h6><strong>Nova Scotia Community College</strong> | September 2020 - April 2022 (IT Web Programming)</h6>
                        <p>- Excelled in IT Web Programming. Gained tons of practical 
                           web development skills and was exposed to many 
                           different technologies.
                        </p>
                        <p>- Soon graduating with a diploma.</p>
                     </div>
                  </div>
                  <div id="smu">
                     <div id="smu-content">
                        <img id="smu-logo" src={props.smuLogo}/>
                        <h6><strong>Saint Mary's University</strong> | September 2018 - April 2019 (Computer Science)</h6>
                        <p>- Completed 1 year of computer science, but wanted 
                           more practical knowledge and skills.
                        </p>
                        <h6>September 2017 - April 2018 (Engineering)</h6>
                        <p>- Completed 1 year of engineering, but quickly realized 
                           I wasn't interested.
                        </p>
                     </div>   
                  </div>
               </div>
            </div>
         </div>

         {/* <div className="section" id="work-experience">
            <div className="home-section-content">
               <h1>Work Experience</h1>
               <p>
                  Stuff
               </p>
            </div>   
         </div> */}

         <div className="home-section" id="projects">
            <div className="home-section-content">
               <h1>Projects</h1>
               <p>
                  I've created many applications during my time at NSCC. I'm 
                  currently working on a calorie counter mobile app as a 
                  personal project. 
               </p>
               <Link to="/projects">Go to projects</Link>
            </div>
            <div className="home-projects-teaser">
               <img id="projects-preview-img" src={props.projectsPreview}></img>
            </div>
         </div>

         <div className="home-section" id="projects-mobile">
            <div className="home-section-content">
               <h1>Projects</h1>
               <p>
                  I've created many applications during my time at NSCC. I'm 
                  currently working on a calorie counter mobile app as a 
                  personal project. 
               </p>
               <img id="projects-preview-img" src={props.projectsPreview}></img>
               <Link to="/projects">Go to projects</Link>
            </div>
         </div>

         {/* <div className="home-section" id="achievments">
            <div className="home-section-content">
               <h1>Achievments</h1>
               <p>
                  Stuff
               </p>
            </div>
         </div> */}

         <div className="home-section" id="contact">
            <div className="home-section-content">
               <h1>Contact me</h1>
               <p>Email: <a href="mailto:maxmorse-dev@outlook.com">maxmorse-dev@outlook.com</a></p>
               {/* <p>Phone: <a href="tel:9028306830">(902)8306830</a></p> */}
               <a href="https://www.linkedin.com/in/max-morse/" target="_blank">Linkedin</a>
               <Link to="/resume">Go to resume</Link>
            </div>
         </div>
      </div>
   );
}

export default Home;